exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.description .description-text[data-v-bf749d6c] {\n    color: #90919e;\n    font-size: 14px;\n    line-height: 20px;\n}\n", ""]);

// exports
